var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClinicInactive = function SvgClinicInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Sidebar-/-Default",
    transform: "translate(-16.000000, -190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,2.99999996 C13.3284271,2.99999996 14,3.67157284 14,4.49999996 L14,4.99999996 L15.5,4.99999997 C16.5543618,4.99999997 17.4181651,5.81587776 17.4945142,6.85073762 L17.5,6.99999997 L17.5,15 C17.5,16.1045695 16.6045695,17 15.5,17 L4.49999995,17 C3.39543046,17 2.49999995,16.1045695 2.49999995,15 L2.49999995,6.99999997 C2.49999995,5.89543047 3.39543046,4.99999997 4.49999995,4.99999997 L5.99999995,4.99999996 L5.99999997,4.49999996 C5.99999997,3.67157284 6.67157285,2.99999996 7.49999997,2.99999996 L12.5,2.99999996 Z M15.5,5.99999997 L4.49999996,5.99999997 C3.94771521,5.99999997 3.49999996,6.44771523 3.49999996,6.99999997 L3.49999996,15 C3.49999996,15.5522848 3.94771521,16 4.49999996,16 L15.5,16 C16.0522848,16 16.5,15.5522848 16.5,15 L16.5,6.99999997 C16.5,6.44771523 16.0522848,5.99999997 15.5,5.99999997 Z M10,7.99999999 C10.2761424,7.99999999 10.5,8.22385761 10.5,8.49999999 L10.5,10.5 L12.5,10.5 C12.7761424,10.5 13,10.7238576 13,11 C13,11.2761424 12.7761424,11.5 12.5,11.5 L10.5,11.5 L10.5,13.5 C10.5,13.7761424 10.2761424,14 10,14 C9.72385762,14 9.5,13.7761424 9.5,13.5 L9.49999995,11.5 L7.49999998,11.5 C7.22385761,11.5 6.99999998,11.2761424 6.99999998,11 C6.99999998,10.7238576 7.22385761,10.5 7.49999998,10.5 L9.49999995,10.5 L9.5,8.49999999 C9.5,8.22385761 9.72385762,7.99999999 10,7.99999999 Z M12.5,3.99999996 L7.49999997,3.99999996 C7.22385761,3.99999996 6.99999997,4.22385759 6.99999997,4.49999996 L6.99999995,4.99999996 L13,4.99999996 L13,4.49999996 C13,4.22385759 12.7761424,3.99999996 12.5,3.99999996 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClinicInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clinic-inactive.936ea106.svg";
export { ForwardRef as ReactComponent };